(() => {
  const initialise = (root) => {
    root.querySelectorAll('[data-mirror-background]').forEach((background) => {
      if (background.dataset.mirrorInitialised) return;
      background.dataset.mirrorInitialised = 'true';
      const image = background.querySelector('.rz-launch__background-image');
      if (!image) return;
      let frame;
      const draw = () => {
        if (!background.isConnected || !image.naturalWidth || !image.naturalHeight) return;
        const width = background.clientWidth;
        const height = background.clientHeight;
        if (!width || !height) return;
        const ratio = image.naturalWidth / image.naturalHeight;
        const tileWidth = Math.min(width, height * ratio);
        const tileHeight = tileWidth / ratio;
        // Odd tile counts put the complete, unreflected image in the centre.
        const oddCount = (size, tile) => {
          const count = Math.ceil(size / tile) + 2;
          return count % 2 ? count : count + 1;
        };
        const columns = oddCount(width, tileWidth);
        const rows = oddCount(height, tileHeight);
        const middleX = (columns - 1) / 2;
        const middleY = (rows - 1) / 2;
        const grid = document.createElement('div');
        grid.className = 'rz-launch__mirror-grid';
        grid.style.width = `${columns * tileWidth}px`;
        grid.style.height = `${rows * tileHeight}px`;
        grid.style.gridTemplateColumns = `repeat(${columns}, ${tileWidth}px)`;
        grid.style.gridTemplateRows = `repeat(${rows}, ${tileHeight}px)`;
        for (let y = 0; y < rows; y++) {
          for (let x = 0; x < columns; x++) {
            const tile = image.cloneNode(false);
            tile.removeAttribute('srcset');
            tile.removeAttribute('sizes');
            tile.removeAttribute('fetchpriority');
            tile.src = image.currentSrc || image.src;
            tile.className = 'rz-launch__mirror-tile';
            tile.style.transform = `scale(${Math.abs(x - middleX) % 2 ? -1 : 1}, ${Math.abs(y - middleY) % 2 ? -1 : 1})`;
            grid.appendChild(tile);
          }
        }
        background.querySelector('.rz-launch__mirror-grid')?.remove();
        background.appendChild(grid);
        background.classList.add('rz-launch__background--mirror-ready');
      };
      const schedule = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(draw);
      };
      const observer = new ResizeObserver(schedule);
      observer.observe(background);
      image.addEventListener('load', schedule);
      if (image.complete) schedule();
      const onUnload = (event) => {
        if (!event.target.contains(background)) return;
        observer.disconnect();
        cancelAnimationFrame(frame);
        document.removeEventListener('shopify:section:unload', onUnload);
      };
      document.addEventListener('shopify:section:unload', onUnload);
    });
  };
  initialise(document);
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
